import { render, staticRenderFns } from "./BenefitMedicalInsurance.vue?vue&type=template&id=70054338"
import script from "./BenefitMedicalInsurance.vue?vue&type=script&lang=js"
export * from "./BenefitMedicalInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports